// ███ AN EXPIRED SESSION, SAID ONCE AND WITH THE REMEDY THAT WORKS ███ (2026-11-01)
//
// Manual session M5 item 1 (docs/manual/M5-report.md § 5): profiles signed in
// hours earlier got 401 from `createConversation` and `commsMessage` on EVERY
// page load; the Comms banner said "Reloading tries again" (false — a reload
// did not clear it) and a send showed a bare "Unauthorized". Signing in again
// cleared it at once. memory/auth0-id-token-expiry-401.md has the diagnosis.
//
// WHAT THE CLIENT ALREADY DOES: `src/auth/auth0.js` uses refresh tokens
// (`useRefreshTokens: true`, `offline_access` in scope, #71) and
// `functionAuthInterceptor.js` retries a 401 once after a forced refresh. When
// the retry STILL answers 401 the refresh did not produce a usable token —
// the refresh token itself has expired or been revoked, or the tenant does
// not issue one — and nothing the client can do short of a new sign-in will
// change that. That is the state this module names.
//
// THE TENANT HALF IS CONNOR'S (not done here, never signed in from here): in
// the Auth0 dashboard, the SPA application's "Allow Offline Access" grant and
// the Refresh Token settings (rotation; absolute and inactivity lifetimes). A
// refresh token with an inactivity lifetime shorter than a day explains "signed
// in hours earlier, every page load 401" exactly. The client side below works
// with or without that change: it turns a persistent 401 into a sentence and a
// control that signs the person in again.
//
// ⚠ NOT A STORE. A plain reactive flag, like notificationStore: the
// interceptor is installed before Pinia exists.
import { reactive, readonly } from 'vue';

export const SESSION_EXPIRED = 'Your sign-in has expired, so this could not be sent. Sign in again to continue.';
export const SIGN_IN_AGAIN = 'Sign in again';

const state = reactive({ expired: false });

/** Called by the interceptor when a 401 survives the token refresh. */
export function markSessionExpired() {
  state.expired = true;
}

/** Test seam, and the reset a fresh sign-in implies. */
export function clearSessionExpired() {
  state.expired = false;
}

export const sessionState = readonly(state);

/**
 * The remedy that works: a new sign-in. Delegates to `startLogin`, which is
 * the one login entry point every screen already uses (it survives storage
 * failures and carries the deep link). Imported LAZILY, and that is load-
 * bearing: `startLogin` imports the Auth0 client, and this module is imported
 * by screens (CommsChat, ConversationThread) whose tests must mount without
 * it — a static import here pulled `createAuth0` into four unrelated suites.
 */
export async function signInAgain() {
  const { startLogin } = await import('./startLogin');
  return startLogin();
}
